import Icon from '../components/Icon.vue'

Icon.register({
  'ticket-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M128 160h320v192h-320v-192zM528 256c0 26.5 21.5 48 48 48v96c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-96c26.5 0 48-21.5 48-48s-21.5-48-48-48v-96c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48v96c-26.5 0-48 21.5-48 48zM480 152c0-13.3-10.7-24-24-24h-336c-13.3 0-24 10.7-24 24v208c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ticket-alt.js
// module id = 2009
// module chunks = 0